export default __webpack_public_path__ + "static/media/typography-colors.f9c6f935.jpg";